import { PaymentType as ApiPaymentType } from '@/features/graphql/generated/graphql'
import { PaymentType as AppPaymentType } from '@/features/orders/constants/app'
import invert from 'lodash.invert'

export const apiToAppPaymentType: Record<ApiPaymentType, AppPaymentType> = {
    [ApiPaymentType.CardOnsite]: AppPaymentType.CardOnsite,
    [ApiPaymentType.Cash]: AppPaymentType.Cash,
    [ApiPaymentType.Invoice]: AppPaymentType.Invoice,
    [ApiPaymentType.MealVoucher]: AppPaymentType.MealVoucher,
    [ApiPaymentType.MealVoucherCard]: AppPaymentType.MealVoucherCard,
    [ApiPaymentType.Online]: AppPaymentType.Online,
}

export const appToApiPaymentType = invert(apiToAppPaymentType) as Record<
    AppPaymentType,
    ApiPaymentType
>
